import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import axios from "../../axios-vmou";
import { classNames } from "primereact/utils";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import Navbar from "../main/navbar";
import logo from "../../assets/vmou.png";
import { Sidebar } from 'primereact/sidebar';
import { Dialog } from "primereact/dialog";
import styles from "./profile.module.css";
import { useHistory } from "react-router-dom";

const Profile = (props) => {
  const [visibleRight, setVisibleRight] = useState(false);
  const onSignout = () => {
    props.onlogout();
  }
  const [examinerDialog, setExaminerDialog] = useState(true);
  const [examiner, setExaminer] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const toast = useRef(null);
  const history = useHistory()

  useEffect(() => {
    let authOptions = {
      method: "GET",
      url: "/examiner/"+props.email,
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
    };
    axios(authOptions)
      .then((response) => {
        setExaminer(response.data);
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail: error.response.data,
        });
        setExaminer('');
      });
  }, [props.email]); 

  const saveExaminer = () => {
    setSubmitted(true);
    if (!examiner.panno || examiner.panno.length === 0){
      toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Please Enter PAN No', life: 3000 });
      return;
    }
    if (!examiner.accno || examiner.accno.length === 0){
      toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Please Enter Account No', life: 3000 });
      return;
    }
    if (!examiner.ifsccode || examiner.ifsccode.length === 0){
      toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Please Enter Branch IFSC Code', life: 3000 });
      return;
    }
    if (!examiner.branch || examiner.branch.length === 0){
      toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Please Enter Branch Name', life: 3000 });
      return;
    }
    if (!examiner.bank || examiner.bank.length === 0){
      toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Please Enter Bank Name', life: 3000 });
      return;
    }
    if (!examiner.phone || examiner.phone.length === 0){
      toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Please Enter Phone No', life: 3000 });
      return;
    }
    if (!examiner.name || examiner.name.length === 0){
      toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Please Enter Examiner Name', life: 3000 });
      return;
    }

    if (examiner.name.trim()) {
      let _examiner = { ...examiner };
      // _examiner.userid = props.userid;
      let authOptions = {
        method: "PUT",
        url: "/examiner/",
        data: _examiner,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      };
      axios(authOptions)
        .then((response) => {
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Examiner Edited",
            life: 3000,
          });
          setExaminerDialog(false);
          setExaminer('');
          history.goBack();
      
        })
        .catch((error) => {
          toast.current.show({
            severity: "error",
            summary: "Error Message",
            detail: error.response.data,
          });
        });
      }
  };

  const hideDialog = () => {
    setSubmitted(false);
    setExaminerDialog(false);
    history.goBack();

  };
  const examinerDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDialog}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        className="p-button-text"
        onClick={saveExaminer}
      />
    </React.Fragment>
  );

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _examiner = { ...examiner };
    _examiner[`${name}`] = val;
    setExaminer(_examiner);
  };

  return (
    <div className={styles.datatablecruddemo}>
      <Toast ref={toast} />
      <Sidebar className="flex align-items-center " visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
          <h2>User Profile....</h2>
          <h5>Examiner ID : {props.email}</h5>
          <h5>Name        : {props.username}</h5>
          <Button className="p-button-text p-button-danger ml-4" style={{}} onClick={onSignout}>Sign Out</Button>
        </Sidebar>
      <div className="Headerusr" style={{ position: "sticky" }}>
        <img
          src={logo}
          alt="VMOU"
          height={100}
          width={90}
          style={{ margin: "0px 0 0 20px" }}
        ></img>
        <h2 style={{ marginTop: "0", textAlign: "center" }}>
          Examiner Module
          <br />
          Examiner Profile
        </h2>
        <div className="Userusr" onClick={(e) => setVisibleRight(true)}>
          <i style={{'fontSize': '1.5em'}} className="pi pi-user mr-6 mt-2 text-right"></i>
          <h4 style={{margin:'0 30px 0 0',textAlign:'end'}} >Hi, {props.username}</h4>
        </div>
      </div>
      <Navbar />
      <Dialog visible={examinerDialog} style={{ width: "450px" }} header="Examiner Details" modal className="p-fluid" footer={examinerDialogFooter} onHide={hideDialog}>
        <div className="p-field">
            <label htmlFor="email">Email ID*</label>
            <InputText value={examiner.email}/>
            {submitted && !examiner.email && (
                <small className="p-error">Email Id is required.</small>
            )}
        </div>
        <div className="p-field">
            <label htmlFor="name">Examiner Name*</label>
            <InputText id="name" value={examiner.name} onChange={(e) => onInputChange(e, "name")} required  className={classNames({ "p-invalid": submitted && !examiner.name })}/>
            {submitted && !examiner.name && (
                <small className="p-error">Name is required.</small>
            )}
        </div>
        <div className="p-field">
            <label htmlFor="phone">Contact No*</label>
            <InputText id="phone" value={examiner.phone} onChange={(e) => onInputChange(e, "phone")} required className={classNames({"p-invalid": submitted && !examiner.phone })}/>
            {submitted && !examiner.phone && (
                <small className="p-error">Pnone is required.</small>
            )}
        </div>
        <div className="p-field">
            <label htmlFor="phone]">Bank Name*</label>
            <InputText id="bank" value={examiner.bank} onChange={(e) => onInputChange(e, "bank")} required className={classNames({"p-invalid": submitted && !examiner.bank })}/>
            {submitted && !examiner.bank && (
                <small className="p-error">Bank is required.</small>
            )}
        </div>
        <div className="p-field">
            <label htmlFor="name">Branch Name*</label>
            <InputText id="name" value={examiner.branch} onChange={(e) => onInputChange(e, "branch")} required className={classNames({"p-invalid": submitted && !examiner.branch })}/>
            {submitted && !examiner.branch && (
                <small className="p-error">Branch is required.</small>
            )}
        </div>
        <div className="p-field">
            <label htmlFor="ifsccode">IFSC Code*</label>
            <InputText id="ifsccode" value={examiner.ifsccode} onChange={(e) => onInputChange(e, "ifsccode")} required className={classNames({"p-invalid": submitted && !examiner.ifsccode })}/>
            {submitted && !examiner.ifsccode && (
                <small className="p-error">IFSC Code is required.</small>
            )}
        </div>
        <div className="p-field">
            <label htmlFor="accno">Account No*</label>
            <InputText id="accno" value={examiner.accno} onChange={(e) => onInputChange(e, "accno")} required className={classNames({"p-invalid": submitted && !examiner.accno })}/>
            {submitted && !examiner.accno && (
                <small className="p-error">Account No is required.</small>
            )}
        </div>
        <div className="p-field">
            <label htmlFor="name">PAN No*</label>
            <InputText id="panno" value={examiner.panno} onChange={(e) => onInputChange(e, "panno")} required className={classNames({"p-invalid": submitted && !examiner.panno })}/>
            {submitted && (!examiner.panno || examiner.panno.length===0) && (
                <small className="p-error">PAN No is required.</small>
            )}
        </div>
      </Dialog>
    </div>
  )
}

const mapStateToProps = state => {
    return {
        username:state.auth.username,
        userid:state.auth.userid,
        email:state.auth.email,
        isAuth:state.auth.token!==null,
    }
}
  
export default connect(mapStateToProps)(Profile);